import React from 'react';
import { render } from 'react-dom';
import './RosterTable.css';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { getHenriStyle, round } from '../Utility/utility.js';
import { NonRosteredTable } from './NonRosteredTable';
import { PlayerCard } from '../Components/PlayerCard';
import axios from 'axios';
import { apiServerUrl } from '../config';
import { authHeader, requestOptions, jwtTeam } from '../_helpers';

// fake data generator
const getItems = (count, offset = 0) =>
  Array.from({ length: count }, (v, k) => k).map(k => ({
    id: `item-${k + offset}`,
    content: `item ${k + offset}`
  }));

// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  //console.log("after splicing" + JSON.stringify(result));
  return result;
};

/**
 * Moves an item from one list to another list.
 */
const move = (source, destination, droppableSource, droppableDestination) => {
  console.log(source);
  console.log(destination);
  console.log(droppableSource);
  console.log(droppableDestination);
  const sourceClone = Array.from(source);
  const destClone = Array.from(destination);
  const [removed] = sourceClone.splice(droppableSource.index, 1);

  destClone.splice(droppableDestination.index, 0, removed);

  const result = {};
  result[droppableSource.droppableId] = sourceClone;
  result[droppableDestination.droppableId] = destClone;

  return result;
};

/*onClick: () => {
  {this.props.toggleActive(instance.props.data[rowInfo.index].playerID)}
}*/
const grid = 8;

export class RosterTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      leftWing: this.props.team.filter(
        x =>
          x.depth_chart_position == 'LW' &&
          x.league == 'NHL' &&
          x.roster_status == 'ROSTERED'
      ),
      center: this.props.team.filter(
        x =>
          x.depth_chart_position == 'C' &&
          x.league == 'NHL' &&
          x.roster_status == 'ROSTERED'
      ),
      rightWing: this.props.team.filter(
        x =>
          x.depth_chart_position == 'RW' &&
          x.league == 'NHL' &&
          x.roster_status == 'ROSTERED'
      ),
      leftD: this.props.team.filter(
        x =>
          x.depth_chart_position == 'LD' &&
          x.league == 'NHL' &&
          x.roster_status == 'ROSTERED'
      ),
      rightD: this.props.team.filter(
        x =>
          x.depth_chart_position == 'RD' &&
          x.league == 'NHL' &&
          x.roster_status == 'ROSTERED'
      ),
      goalies: this.props.team.filter(
        x =>
          x.depth_chart_position == 'G' &&
          x.league == 'NHL' &&
          x.roster_status == 'ROSTERED'
      ),
      forwardScores: [],
      otherScores: [],
      nonRoster: this.props.team.filter(x => x.roster_status == 'NON-ROSTER'),
      activeTeam: this.props.activeTeam
    };
    this.handleClick = this.handleClick.bind(this);
    this.saveRoster = this.saveRoster.bind(this);
  }
  componentWillMount() {
    //console.log("mount roster table");
    //console.log("mount roster table" + JSON.stringify(this.props.team));
    let currentComponent = this;
    currentComponent.setState({
      leftWing: this.props.team
        .filter(x => x.depth_chart_position == 'LW' && x.league == 'NHL')
        .sort((a, b) => {
          a = a.depth_chart_rank === null ? -Infinity : a;
          b = b.depth_chart_rank === null ? -Infinity : b;
          return a.depth_chart_rank > b.depth_chart_rank;
        }),
      center: this.props.team
        .filter(x => x.depth_chart_position == 'C' && x.league == 'NHL')
        .sort((a, b) => {
          a = a.depth_chart_rank === null ? -Infinity : a;
          b = b.depth_chart_rank === null ? -Infinity : b;
          return a.depth_chart_rank > b.depth_chart_rank;
        }),
      rightWing: this.props.team
        .filter(x => x.depth_chart_position == 'RW' && x.league == 'NHL')
        .sort((a, b) => {
          a = a.depth_chart_rank === null ? -Infinity : a;
          b = b.depth_chart_rank === null ? -Infinity : b;
          return a.depth_chart_rank > b.depth_chart_rank;
        }),
      leftD: this.props.team
        .filter(x => x.depth_chart_position == 'LD' && x.league == 'NHL')
        .sort((a, b) => {
          a = a.depth_chart_rank === null ? -Infinity : a;
          b = b.depth_chart_rank === null ? -Infinity : b;
          return a.depth_chart_rank > b.depth_chart_rank;
        }),
      rightD: this.props.team
        .filter(x => x.depth_chart_position == 'RD' && x.league == 'NHL')
        .sort((a, b) => {
          a = a.depth_chart_rank === null ? -Infinity : a;
          b = b.depth_chart_rank === null ? -Infinity : b;
          return a.depth_chart_rank > b.depth_chart_rank;
        }),
      goalies: this.props.team
        .filter(x => x.depth_chart_position == 'G' && x.league == 'NHL')
        .sort((a, b) => {
          a = a.depth_chart_rank === null ? -Infinity : a;
          b = b.depth_chart_rank === null ? -Infinity : b;
          return a.depth_chart_rank > b.depth_chart_rank;
        }),
      nonRoster: this.props.team.filter(x => x.roster_status == 'NON-ROSTER'),
      activeTeam: this.props.activeTeam
    });
    this.calculateLineScore();
  }
  //component
  componentDidUpdate() {
    //console.log('roster talbe props' + this.props.activeTeam + "state" + this.state.activeTeam);
    if (this.state.activeTeam != this.props.activeTeam) {
      this.setState({
        leftWing: this.props.team
          .filter(x => x.depth_chart_position == 'LW' && x.league == 'NHL')
          .sort((a, b) => {
            a = a.depth_chart_rank === null ? -Infinity : a;
            b = b.depth_chart_rank === null ? -Infinity : b;
            return a.depth_chart_rank > b.depth_chart_rank;
          }),
        center: this.props.team
          .filter(x => x.depth_chart_position == 'C' && x.league == 'NHL')
          .sort((a, b) => {
            a = a.depth_chart_rank === null ? -Infinity : a;
            b = b.depth_chart_rank === null ? -Infinity : b;
            return a.depth_chart_rank > b.depth_chart_rank;
          }),
        rightWing: this.props.team
          .filter(x => x.depth_chart_position == 'RW' && x.league == 'NHL')
          .sort((a, b) => {
            a = a.depth_chart_rank === null ? -Infinity : a;
            b = b.depth_chart_rank === null ? -Infinity : b;
            return a.depth_chart_rank > b.depth_chart_rank;
          }),
        leftD: this.props.team
          .filter(x => x.depth_chart_position == 'LD' && x.league == 'NHL')
          .sort((a, b) => {
            a = a.depth_chart_rank === null ? -Infinity : a;
            b = b.depth_chart_rank === null ? -Infinity : b;
            return a.depth_chart_rank > b.depth_chart_rank;
          }),
        rightD: this.props.team
          .filter(x => x.depth_chart_position == 'RD' && x.league == 'NHL')
          .sort((a, b) => {
            a = a.depth_chart_rank === null ? -Infinity : a;
            b = b.depth_chart_rank === null ? -Infinity : b;
            return a.depth_chart_rank > b.depth_chart_rank;
          }),
        goalies: this.props.team
          .filter(x => x.depth_chart_position == 'G' && x.league == 'NHL')
          .sort((a, b) => {
            a = a.depth_chart_rank === null ? -Infinity : a;
            b = b.depth_chart_rank === null ? -Infinity : b;
            return a.depth_chart_rank > b.depth_chart_rank;
          }),
        forwardScores: [],
        otherScores: [],
        nonRoster: this.props.team.filter(x => x.roster_status == 'NON-ROSTER'),
        activeTeam: this.props.activeTeam
      });
      //console.log("before calculating line score");
      this.calculateLineScore();
    }
  }
  saveRoster() {
    let players = [];
    let rosters = [
      'leftWing',
      'rightWing',
      'center',
      'leftD',
      'rightD',
      'goalies',
      'nonRoster'
    ];

    for (let i = 0; i < this.state.leftWing.length; i++) {
      players.push(this.state.leftWing[i]);
    }
    for (let i = 0; i < this.state.rightWing.length; i++) {
      players.push(this.state.rightWing[i]);
    }
    for (let i = 0; i < this.state.center.length; i++) {
      players.push(this.state.center[i]);
    }
    for (let i = 0; i < this.state.leftD.length; i++) {
      players.push(this.state.leftD[i]);
    }
    for (let i = 0; i < this.state.rightD.length; i++) {
      players.push(this.state.rightD[i]);
    }
    for (let i = 0; i < this.state.goalies.length; i++) {
      players.push(this.state.goalies[i]);
    }
    for (let i = 0; i < this.state.nonRoster.length; i++) {
      players.push(this.state.nonRoster[i]);
    }
    console.log('saving');
    console.log(this.state.leftWing);
    console.log(JSON.stringify(players));
    console.log(players);
    axios
      .post(
        apiServerUrl + '/save_roster',
        {
          depth_chart: players
        },
        requestOptions()
      )
      .then(function(response) {
        console.log(response);
      })
      .catch(function(error) {
        console.log(error);
      });
  }
  calculateLineScore() {
    //let score = this.state.leftWing[0].henri + this.state.rightWing[0].henri + this.state.center[0].henri / 3;
    ////console.log("score is" + this.state.leftWing[0].henri + " ; + " + this.state.rightWing[0].henri + "s" + this.state.center[0].henri);
    ////console.log("score is" + score);
    let forwardScores = [];
    for (
      let i = 0;
      i <
      Math.max(
        this.state.leftWing.length,
        this.state.rightWing.length,
        this.state.center.length
      );
      i++
    ) {
      let sum = 0;
      let numScores = 0;
      if (this.state.leftWing[i]) {
        ////console.log("adding " + this.state.leftWing[i].henri + this.state.leftWing[i].name);
        sum += this.state.leftWing[i].henri;
        numScores++;
      }
      if (this.state.rightWing[i]) {
        ////console.log("adding " + this.state.rightWing[i].henri + this.state.rightWing[i].name);
        sum += this.state.rightWing[i].henri;
        numScores++;
      }
      if (this.state.center[i]) {
        ////console.log("adding " + this.state.center[i].henri + this.state.center[i].name);
        sum += this.state.center[i].henri;
        numScores++;
      }
      ////console.log("sum" + sum.toFixed(2));
      sum = (sum.toFixed(2) / numScores).toFixed(2);
      forwardScores.push(sum);
    }
    let otherScores = [];
    for (
      let i = 0;
      i < Math.max(this.state.leftD.length, this.state.rightD.length);
      i++
    ) {
      let sum = 0;
      let numScores = 0;
      if (this.state.leftD[i]) {
        ////console.log("adding " + this.state.leftD[i].henri + this.state.leftD[i].name);
        sum += this.state.leftD[i].henri;
        numScores++;
      }
      if (this.state.rightD[i]) {
        ////console.log("adding " + this.state.rightD[i].henri + this.state.rightD[i].name);
        sum += this.state.rightD[i].henri;
        numScores++;
      }
      ////console.log("sum" + sum.toFixed(2));
      sum = (sum.toFixed(2) / numScores).toFixed(2);
      otherScores.push(sum);
    }
    //console.log("set state after calc");
    this.setState({
      //forwardScores: [((this.state.leftWing[0].henri + this.state.rightWing[0].henri + this.state.center[0].henri) / 3).toFixed(2)]
      forwardScores: forwardScores,
      otherScores: otherScores
    });
  }
  handleClick() {
    //console.log("CLICKED");
  }
  id2List = {
    leftWing: 'leftWing',
    center: 'center',
    rightWing: 'rightWing',
    leftD: 'leftD',
    rightD: 'rightD',
    nonRoster: 'nonRoster'
  };

  id2Position = {
    leftWing: 'LW',
    center: 'C',
    rightWing: 'RW',
    leftD: 'LD',
    rightD: 'RD',
    goalies: 'G'
  };

  reIndex(players, position) {
    const newArray = players.map((value, index, array) => {
      console.log(value, index, array);
      value.depth_chart_rank = index;

      if (position == 'nonRoster') {
        value.roster_status = 'NON-ROSTER';
        //Don't change em
        value.depth_chart_position = position;
      } else {
        value.roster_status = 'ROSTERED';
        value.depth_chart_position = this.id2Position[position];
      }
      return value;
    });
    console.log(newArray);
    return newArray;
  }
  getList = id => this.state[this.id2List[id]];

  onDragEnd = result => {
    const { source, destination } = result;
    console.log(source);
    console.log(source.droppableId);
    console.log(destination);

    // dropped outside the list
    if (!destination) {
      return;
    }

    if (source.droppableId === destination.droppableId) {
      const items = reorder(
        this.getList(source.droppableId),
        source.index,
        destination.index
      );

      let state = { items };
      state = { droppableId: items };

      let example = [source.droppableId];

      console.log(source);
      console.log(example);
      this.setState({
        [example]: this.reIndex(items)
      });
    } else {
      const result = move(
        this.getList(source.droppableId),
        this.getList(destination.droppableId),
        source,
        destination
      );
      console.log('result' + JSON.stringify(result));
      let example = Object.keys(result);
      console.log(example[0]);
      let test = example[0];
      let test2 = example[1];
      let result1 = result[test];
      let result2 = result[test2];
      this.setState({
        [example[0]]: this.reIndex(result1, example[0]),
        [example[1]]: this.reIndex(result2, example[1])
      });
    }
    //Update the linescores
    this.calculateLineScore();
  };

  HenriCellColorClass(value) {
    if (value == null) {
      return 'roster-grey-cell';
    } else if (
      value.split('m')[0] < 2.0 ||
      value.split('k')[0] < 1000 ||
      value == 'RED'
    ) {
      return 'roster-red-cell';
    } else if (value.split('m')[0] < 5.0 || value == 'YELLOW') {
      return 'roster-yellow-cell';
    } else if (value.split('m')[0] < 7.0 || value == 'GREEN') {
      return 'roster-green-cell';
    } else if (
      value.split('m')[0] > 7.0 ||
      value == 'BLUE' ||
      value == 'Blue'
    ) {
      return 'roster-blue-cell';
    } else {
      return 'roster-grey-cell';
    }
  }

  render() {
    return (
      <div>
        <DragDropContext onDragEnd={this.onDragEnd}>
          <div className="roster" style={{ flex: 8 }}>
            <div className="roster-table" style={{ flex: 8 }}>
              <div className="roster-table-row">
                {this.props.side == 'right' && (
                  <div
                    className="roster-table-column-line-score"
                    style={{ flex: 0.5 }}
                  >
                    <div className="roster-table-column-header">CAP</div>
                    {this.state.forwardScores.map(item => (
                      <div
                        className={
                          'roster-table-cell-2 ' +
                          this.HenriCellColorClass(round(item))
                        }
                      >
                        <div>
                          <strong>{round(item)}</strong>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
                <Droppable droppableId="leftWing">
                  {(provided, snapshot) => (
                    <div
                      className="roster-table-column"
                      ref={provided.innerRef}
                    >
                      <div className="roster-table-column-header">
                        LEFT WING
                      </div>
                      {[]
                        .concat(this.state.leftWing)
                        .sort((a, b) => {
                          a = a.depth_chart_rank === null ? -Infinity : a;
                          b = b.depth_chart_rank === null ? -Infinity : b;
                          return a.depth_chart_rank > b.depth_chart_rank;
                        })
                        .map((item, index) => (
                          <Draggable
                            key={item.playerid}
                            draggableId={item.playerid}
                            index={index}
                          >
                            {(provided, snapshot) => (
                              <div
                                className={
                                  'roster-table-cell-2 ' +
                                  this.HenriCellColorClass(round(item.henri))
                                }
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                                data-playerID={item.playerid}
                                onClick={this.props.toggleActive.bind(
                                  this,
                                  item.playerid
                                )}
                              >
                                {/*{this.HenriCellColor(item.henri)}*/}
                                <div className="roster-table-cell-top">
                                  <div>
                                    {' '}
                                    #{item.number} {item.first_name[0]}.{' '}
                                    {item.last_name}
                                  </div>
                                </div>
                                <div className="roster-table-cell-bottom">
                                  <div>
                                    ATOI: {Math.round(item.atoi * 100) / 100}
                                  </div>
                                  {/*<div style={{ visibility: this.state.driverDetails.firstName != undefined? 'visible': 'hidden'}}></div>*/}
                                  <div>HENRI: ${round(item.henri)}</div>
                                </div>
                              </div>
                            )}
                          </Draggable>
                        ))}
                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>
                <Droppable droppableId="center">
                  {(provided, snapshot) => (
                    <div
                      className="roster-table-column"
                      ref={provided.innerRef}
                    >
                      <div className="roster-table-column-header">CENTER</div>
                      {[]
                        .concat(this.state.center)
                        .sort((a, b) => {
                          a = a.depth_chart_rank === null ? -Infinity : a;
                          b = b.depth_chart_rank === null ? -Infinity : b;
                          return a.depth_chart_rank > b.depth_chart_rank;
                        })
                        .map((item, index) => (
                          <Draggable
                            key={item.playerid}
                            draggableId={item.playerid}
                            index={index}
                          >
                            {(provided, snapshot) => (
                              <div
                                className={
                                  'roster-table-cell-2 ' +
                                  this.HenriCellColorClass(round(item.henri))
                                }
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                                onClick={this.props.toggleActive.bind(
                                  this,
                                  item.playerid
                                )}
                              >
                                <div className="roster-table-cell-top">
                                  <div>
                                    {' '}
                                    #{item.number} {item.first_name[0]}.{' '}
                                    {item.last_name}
                                  </div>
                                </div>
                                <div className="roster-table-cell-bottom">
                                  <div>
                                    ATOI: {Math.round(item.atoi * 100) / 100}
                                  </div>
                                  {/*<div style={{ visibility: this.state.driverDetails.firstName != undefined? 'visible': 'hidden'}}></div>*/}
                                  <div>HENRI: ${round(item.henri)}</div>
                                </div>
                              </div>
                            )}
                          </Draggable>
                        ))}
                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>
                <Droppable droppableId="rightWing">
                  {(provided, snapshot) => (
                    <div
                      className="roster-table-column"
                      ref={provided.innerRef}
                    >
                      <div className="roster-table-column-header">
                        RIGHT WING
                      </div>
                      {[]
                        .concat(this.state.rightWing)
                        .sort((a, b) => {
                          a = a.depth_chart_rank === null ? -Infinity : a;
                          b = b.depth_chart_rank === null ? -Infinity : b;
                          return a.depth_chart_rank > b.depth_chart_rank;
                        })
                        .map((item, index) => (
                          <Draggable
                            key={item.playerid}
                            draggableId={item.playerid}
                            index={index}
                          >
                            {(provided, snapshot) => (
                              <div
                                className={
                                  'roster-table-cell-2 ' +
                                  this.HenriCellColorClass(round(item.henri))
                                }
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                                onClick={this.props.toggleActive.bind(
                                  this,
                                  item.playerid
                                )}
                              >
                                <div className="roster-table-cell-top">
                                  <div>
                                    {' '}
                                    #{item.number} {item.first_name[0]}.{' '}
                                    {item.last_name}
                                  </div>
                                </div>
                                <div className="roster-table-cell-bottom">
                                  <div>
                                    ATOI: {Math.round(item.atoi * 100) / 100}
                                  </div>
                                  {/*<div style={{ visibility: this.state.driverDetails.firstName != undefined? 'visible': 'hidden'}}></div>*/}
                                  <div>HENRI: ${round(item.henri)}</div>{' '}
                                </div>
                              </div>
                            )}
                          </Draggable>
                        ))}
                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>
                {this.props.side == 'left' && (
                  <div className="roster-table-column-line-score">
                    <div className="roster-table-column-header">CAP</div>
                    {this.state.forwardScores.map(item => (
                      <div
                        className={
                          'roster-table-cell-2 ' +
                          this.HenriCellColorClass(round(item))
                        }
                      >
                        <div>
                          <strong>{round(item)}</strong>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
              <div className="roster-table-row">
                {this.props.side == 'right' && (
                  <div className="roster-table-column-line-score">
                    <div className="roster-table-column-header">CAP</div>
                    {this.state.otherScores.map(item => (
                      <div
                        className={
                          'roster-table-cell-2 ' +
                          this.HenriCellColorClass(round(item))
                        }
                      >
                        <div>
                          <strong>{round(item)}</strong>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
                <Droppable droppableId="leftD">
                  {(provided, snapshot) => (
                    <div
                      className="roster-table-column"
                      ref={provided.innerRef}
                    >
                      <div className="roster-table-column-header">
                        LEFT DEFENSE
                      </div>
                      {[]
                        .concat(this.state.leftD)
                        .sort((a, b) => {
                          a = a.depth_chart_rank === null ? -Infinity : a;
                          b = b.depth_chart_rank === null ? -Infinity : b;
                          return a.depth_chart_rank > b.depth_chart_rank;
                        })
                        .map((item, index) => (
                          <Draggable
                            key={item.playerid}
                            draggableId={item.playerid}
                            index={index}
                          >
                            {(provided, snapshot) => (
                              <div
                                className={
                                  'roster-table-cell-2 ' +
                                  this.HenriCellColorClass(round(item.henri))
                                }
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                                onClick={this.props.toggleActive.bind(
                                  this,
                                  item.playerid
                                )}
                              >
                                <div className="roster-table-cell-top">
                                  <div>
                                    {' '}
                                    #{item.number} {item.first_name[0]}.{' '}
                                    {item.last_name}
                                  </div>
                                </div>
                                <div className="roster-table-cell-bottom">
                                  <div>
                                    ATOI: {Math.round(item.atoi * 100) / 100}
                                  </div>
                                  {/*<div style={{ visibility: this.state.driverDetails.firstName != undefined? 'visible': 'hidden'}}></div>*/}
                                  <div>HENRI: ${round(item.henri)}</div>{' '}
                                </div>
                              </div>
                            )}
                          </Draggable>
                        ))}
                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>

                <Droppable droppableId="rightD">
                  {(provided, snapshot) => (
                    <div
                      className="roster-table-column"
                      ref={provided.innerRef}
                    >
                      <div className="roster-table-column-header">
                        RIGHT DEFENSE
                      </div>
                      {[]
                        .concat(this.state.rightD)
                        .sort((a, b) => {
                          a = a.depth_chart_rank === null ? -Infinity : a;
                          b = b.depth_chart_rank === null ? -Infinity : b;
                          return a.depth_chart_rank > b.depth_chart_rank;
                        })
                        .map((item, index) => (
                          <Draggable
                            key={item.playerid}
                            draggableId={item.playerid}
                            index={index}
                          >
                            {(provided, snapshot) => (
                              <div
                                className={
                                  'roster-table-cell-2 ' +
                                  this.HenriCellColorClass(round(item.henri))
                                }
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                                onClick={this.props.toggleActive.bind(
                                  this,
                                  item.playerid
                                )}
                              >
                                <div className="roster-table-cell-top">
                                  <div>
                                    {' '}
                                    #{item.number} {item.first_name[0]}.{' '}
                                    {item.last_name}
                                  </div>
                                </div>
                                <div className="roster-table-cell-bottom">
                                  <div>
                                    ATOI: {Math.round(item.atoi * 100) / 100}
                                  </div>
                                  {/*<div style={{ visibility: this.state.driverDetails.firstName != undefined? 'visible': 'hidden'}}></div>*/}
                                  <div>HENRI: ${round(item.henri)}</div>{' '}
                                </div>
                              </div>
                            )}
                          </Draggable>
                        ))}
                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>
                <div className="roster-table-column">
                  <div className="roster-table-column-header">GOALIES</div>
                  {[]
                    .concat(this.state.goalies)
                    .sort((a, b) => {
                      a = a.depth_chart_rank === null ? -Infinity : a;
                      b = b.depth_chart_rank === null ? -Infinity : b;
                      return a.depth_chart_rank > b.depth_chart_rank;
                    })
                    .map((item, index) => (
                      <div
                        className={
                          'roster-table-cell-2 ' +
                          this.HenriCellColorClass(round(item.henri))
                        }
                        key={item.playerid}
                        onClick={this.props.toggleActive.bind(
                          this,
                          item.playerid
                        )}
                      >
                        <div className="roster-table-cell-top">
                          <div>
                            {' '}
                            #{item.number} {item.first_name[0]}.{' '}
                            {item.last_name}
                          </div>
                        </div>
                        <div className="roster-table-cell-bottom">
                          <div>ATOI: {Math.round(item.atoi * 100) / 100}</div>
                          {/*<div style={{ visibility: this.state.driverDetails.firstName != undefined? 'visible': 'hidden'}}></div>*/}
                          <div>HENRI: ${round(item.henri)}</div>{' '}
                        </div>
                      </div>
                    ))}
                </div>
                {this.props.side == 'left' && (
                  <div className="roster-table-column-line-score">
                    <div className="roster-table-column-header">CAP</div>
                    {this.state.otherScores.map(item => (
                      <div
                        className={
                          'roster-table-cell-2 ' +
                          this.HenriCellColorClass(round(item))
                        }
                      >
                        <div>
                          <strong>{round(item)}</strong>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
            <div>
              {this.props.side == 'left' && (
                <Droppable droppableId="nonRoster">
                  {(provided, snapshot) => (
                    <div
                      className="roster-table-column"
                      ref={provided.innerRef}
                    >
                      <div className="roster-table-column-header">
                        Non-Rostered
                      </div>
                      {[].concat(this.state.nonRoster).map((item, index) => (
                        <Draggable
                          key={item.playerid}
                          draggableId={item.playerid}
                          index={index}
                        >
                          {(provided, snapshot) => (
                            <div
                              className={
                                'roster-table-cell-2 ' +
                                this.HenriCellColorClass(round(item.henri))
                              }
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                              data-playerID={item.playerid}
                              onClick={this.props.toggleActive.bind(
                                this,
                                item.playerid
                              )}
                            >
                              {/*{this.HenriCellColor(item.henri)}*/}
                              <div className="roster-table-cell-top">
                                <div>
                                  {' '}
                                  #{item.number} {item.first_name[0]}.{' '}
                                  {item.last_name}
                                </div>
                              </div>
                              <div className="roster-table-cell-bottom">
                                <div>Age: {item.age}</div>
                                {/*<div style={{ visibility: this.state.driverDetails.firstName != undefined? 'visible': 'hidden'}}></div>*/}
                                <div>HENRI: ${round(item.henri)}</div>
                              </div>
                            </div>
                          )}
                        </Draggable>
                      ))}
                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>
              )}
              }
            </div>
            {this.props.side == 'left' &&
              this.state.activeTeam == jwtTeam() && (
                <button
                  style={{ maxHeight: '50px', marginTop: '0.5em' }}
                  className="header-account-button"
                  onClick={this.saveRoster}
                >
                  Save Roster
                </button>
              )}
          </div>
          {this.props.side == 'right' &&
            this.props.selectedPlayer && (
              <PlayerCard selectedPlayer={this.props.selectedPlayer} />
            )}
        </DragDropContext>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/RosterTable.js